
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";
import { toast } from "react-toastify";

const RecurringPayments = () => {
  const [rows, setRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedJson, setSelectedJson] = useState(null);
  const [statusFilter, setStatusFilter] = useState("ALL");

  const query = new URLSearchParams(useLocation().search);
  const merchantRequestId = query.get("merchantRequestId");

  // 🔹 Safe JSON parse — flatten "payload" wrapper if present, fall back to outer responseMessage
  const parseResponseJson = (json) => {
    try {
      const parsed = JSON.parse(json || "{}");
      const flat = parsed.payload ? { ...parsed, ...parsed.payload } : parsed;
      // when there is no gateway message (e.g. {"responseCode":"JPEN","responseMessage":"...","status":"FAILURE"}),
      // surface the outer responseMessage so the operator can still see why it failed
      if (!flat.gatewayResponseMessage && parsed.responseMessage) {
        flat.gatewayResponseMessage = parsed.responseMessage;
      }
      return flat;
    } catch {
      return {};
    }
  };

  const fetchRecurringPayments = async () => {
    try {
      const params = { merchantRequestId };

if (statusFilter !== "ALL") {
  params.status = statusFilter;
}

const res = await axiosInstance.get(
  URL.RECURRING_PAYMENTS,
  { params }
);
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      toast.error("Failed to fetch recurring payments");
      setRows([]);
    }
  };

  useEffect(() => {
  if (merchantRequestId) fetchRecurringPayments();
}, [merchantRequestId, statusFilter]);

const filteredRows =
  statusFilter === "ALL"
    ? rows
    : rows.filter(
        (row) =>
          row.status?.toUpperCase() ===
          statusFilter.toUpperCase()
      );

return (
    <div className="container mt-3">
      <h4>Recurring Payments</h4>

      <div className="mb-2">
        <b>Merchant Request ID:</b> {merchantRequestId}
      </div>

      <div className="mb-3">
  <label className="form-label fw-bold">
    Filter Status
  </label>

  <select
    className="form-select"
    style={{ width: "200px" }}
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >
    <option value="ALL">All</option>
    <option value="SUCCESS">Success</option>
    <option value="FAILED">Failed</option>
    <option value="EXPIRED">Expired</option>
  </select>
</div>

      <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
        <table className="table table-sm table-bordered table-hover">
          <thead className="table-dark text-center">
            <tr>
              <th>ID</th>
              <th>Status</th>
              <th>Execute MRID</th>
              <th>Amount</th>
              <th>Gateway Message</th>
              <th>Response JSON</th>
              <th>Created At</th>
            </tr>
          </thead>

          <tbody className="text-center">
            {filteredRows.length ? filteredRows.map((r) => {
              const resp = parseResponseJson(r.responseJson);

              return (
                <tr key={r.id}>
                  <td>{r.id}</td>

                  <td>
                    <span
                      className={`badge ${
                        r.status === "SUCCESS"
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {r.status}
                    </span>
                  </td>

                  <td>{r.executeMerchantRequestId}</td>
                  <td>₹{resp.amount || "-"}</td>
                  <td>{resp.gatewayResponseMessage || "-"}</td>

                  {/* 🔹 VIEW BUTTON */}
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => {
                        setSelectedJson(resp);
                        setShowModal(true);
                      }}
                    >
                      View
                    </button>
                  </td>

                  <td>
                    {r.createdAt
                      ? new Date(r.createdAt).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan="7" className="text-muted">
                  No recurring payment records
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

     {showModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 1050,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    onClick={() => setShowModal(false)}
  >
    <div
      style={{
        background: "#fff",
        width: "70%",
        maxHeight: "80%",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div
        style={{
          padding: "10px 15px",
          borderBottom: "1px solid #ddd",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h5 className="m-0">Response JSON</h5>
        <button
          className="btn-close"
          onClick={() => setShowModal(false)}
        />
      </div>

      {/* BODY */}
      <div
        style={{
          padding: "15px",
          overflowY: "auto",
        }}
      >
        <pre className="bg-light p-3 rounded small">
          {JSON.stringify(selectedJson, null, 2)}
        </pre>
      </div>

      {/* FOOTER */}
      <div
        style={{
          padding: "10px",
          borderTop: "1px solid #ddd",
          textAlign: "right",
        }}
      >
        <button
          className="btn btn-secondary"
          onClick={() => setShowModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default RecurringPayments;
